import { MatingSummary } from '../mating';
import { DomainEntity, Id, Json } from '@homeleite/arch';
import { AnimalEvent, AnimalSummary, EventType } from '../..';
import { BreederSummary } from '../../../breeders';
import { PregnancyDiagnostic } from './pregnancy-diagnostic';
import { AuditData } from '../../auditData';

export class Pregnancy implements DomainEntity, AnimalEvent {

    constructor(
        public readonly id = Id.gen(),
        public date: Date = null,
        public diagnostic: PregnancyDiagnostic = PregnancyDiagnostic.NEGATIVE,
        public animal: AnimalSummary = null,
        public father: BreederSummary = null,
        public mating: MatingSummary = null,
        public type: string = EventType.PREGNANCY.name,
        public created: Date = null,
        public auditData: AuditData = null,
        public animalId: string = null
    ) { }

    toJson(): any {
        return Json.to.simple(this, {
            date: this.date?.toISOString() ?? null,
            diagnostic: this.diagnostic ?? null,
            animal: this.animal?.toJson() ?? null,
            father: this.father?.toJson() ?? null,
            mating: this.mating?.toJson() ?? null,
        });
    }

    static fromJson(json: any): Pregnancy {
        return json ? Json.from.simple(json, Pregnancy, {
            date: json.date ? new Date(json.date) : null,
            diagnostic: json.diagnostic as PregnancyDiagnostic,
            animalId: json.animalId,
            animal: json.animal ? AnimalSummary.fromJson(json.animal) : null,
            father: json.father ? BreederSummary.fromJson(json.father) : null,
            mating: json.mating ? MatingSummary.fromJson(json.mating) : null,
            created: json.created ? new Date(json.created) : null,
            auditData: json.auditData ? AuditData.fromJson(json.auditData) : null
        }) : null;
    }
}
